import { Component, OnInit, ChangeDetectionStrategy, inject } from '@angular/core';

import { CustomNavController } from 'src/shared/providers/navigation/custom-nav-controller';
import { RightSidePanelService } from 'src/shared/providers/providers/right-side-panel';

import { PropertyOptionsPage } from 'src/pages/more/edit-address/property-options/property-options';

import { TidyStorage } from 'src/shared/providers/tidy-storage';
import { WindowService } from 'src/shared/providers/window.service';

@Component({
  template: '',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BookingSuccessRedirectComponent implements OnInit {

  private navCtrl = inject(CustomNavController);
  private rightSidePanelService = inject(RightSidePanelService);
  private storage = inject(TidyStorage);
  private windowService = inject(WindowService);

  async ngOnInit() {
    const params = { isNormalBookingFlow: true };
    await this.storage.save('isNormalBookingFlow', true);

    if (this.windowService.isDesktopRes) {
      this.navCtrl.navigateForward('properties');
      this.rightSidePanelService.navigateTo('property-options', params, PropertyOptionsPage);
    } else {
      this.navCtrl.navigateForward('property-options', params);
    }
  }
}
